import type { NestedFieldDefinition } from '@atlaskit/editor-common/extensions';

export const cqlFieldMap: {
	label: {
		type: string;
		label: string;
		isMultiple: boolean;
		allowDuplicates: boolean;
		isRequired: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	text: {
		type: string;
		op: string;
		label: string;
	};
	contributor: {
		key: string;
		type: string;
		label: string;
		isMultiple: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	creator: {
		key: string;
		type: string;
		label: string;
		isMultiple: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	mention: {
		key: string;
		type: string;
		label: string;
		isMultiple: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	parent: {
		type: string;
		label: string;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	ancestor: {
		type: string;
		label: string;
		isMultiple: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	space: {
		type: string;
		label: string;
		isMultiple: boolean;
		options: {
			resolver: {
				type: string;
			};
		};
	};
	// TODO: https://product-fabric.atlassian.net/browse/ED-10532
	created: {
		type: string;
		op: string;
		label: string;
		description: string;
	};
	lastmodified: {
		type: string;
		op: string;
		label: string;
		description: string;
	};
	title: {
		type: string;
		op: string;
		label: string;
	};
	type: {
		type: string;
		label: string;
		isMultiple: boolean;
		style: string;
		items: {
			value: string;
			label: string;
		}[];
	};
} = {
	label: {
		type: 'custom',
		label: 'Label',
		isMultiple: true,
		allowDuplicates: true,
		isRequired: true,
		options: {
			resolver: {
				type: 'label',
			},
		},
	},

	text: {
		type: 'string',
		op: '~',
		label: 'Including text',
	},

	contributor: {
		key: 'contributor',
		type: 'custom',
		label: 'Contributor',
		isMultiple: true,
		options: {
			resolver: {
				type: 'username',
			},
		},
	},

	creator: {
		key: 'creator',
		type: 'custom',
		label: 'Creator',
		isMultiple: true,
		options: {
			resolver: {
				type: 'username',
			},
		},
	},

	mention: {
		key: 'mention',
		type: 'custom',
		label: 'Mentioning',
		isMultiple: true,
		options: {
			resolver: {
				type: 'username',
			},
		},
	},

	parent: {
		type: 'custom',
		label: 'With parent',
		options: {
			resolver: {
				type: 'confluence-content-by-id',
			},
		},
	},

	ancestor: {
		type: 'custom',
		label: 'With ancestor',
		isMultiple: true,
		options: {
			resolver: {
				type: 'confluence-content-by-id',
			},
		},
	},

	space: {
		type: 'custom',
		label: 'In space',
		isMultiple: true,
		options: {
			resolver: {
				type: 'spacekey',
			},
		},
	},

	// TODO: https://product-fabric.atlassian.net/browse/ED-10532
	created: {
		type: 'string',
		op: '>=',
		label: 'Created after',
		description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.',
	},

	lastmodified: {
		type: 'string',
		op: '<=',
		label: 'Last modified',
		description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.',
	},

	title: {
		type: 'string',
		op: '~',
		label: 'With title',
	},

	type: {
		type: 'enum',
		label: 'Of type',
		isMultiple: false,
		style: 'select',
		items: [
			{ value: 'page', label: 'Page' },
			{ value: 'blogpost', label: 'Blog' },
			{ value: 'comment', label: 'Comment' },
			{ value: 'attachment', label: 'Attachment' },
		],
	},
};

// zip it into an array, adding the name of each entry with it
export const getCQLFields = (): NestedFieldDefinition[] =>
	Object.keys(cqlFieldMap).map((name) => ({
		name,
		...cqlFieldMap[name],
	}));
